var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        [
          _c(
            "a-form",
            { attrs: { slot: "detail", form: _vm.form }, slot: "detail" },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "学生姓名",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["name"],
                                expression: "['name']",
                              },
                            ],
                            attrs: { placeholder: "请输入学生姓名" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.userInfo().username === "admin"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "消息推送设置",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("j-multi-select-tag", {
                                attrs: {
                                  dictCode:
                                    "sys_sms_template,template_name,template_code",
                                  placeholder: "请选择消息推送模版",
                                },
                                model: {
                                  value: _vm.model.smsTemplateCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "smsTemplateCode", $$v)
                                  },
                                  expression: "model.smsTemplateCode",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "所属班级",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("j-search-select-tag", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请输入所属班级",
                              dict: "school_class,name,id,delete_flag=0",
                              async: false,
                            },
                            model: {
                              value: _vm.model.classId,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "classId", $$v)
                              },
                              expression: "model.classId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "关爱等级",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              dictCode: "care_list",
                              placeholder: "请选择关爱等级",
                            },
                            model: {
                              value: _vm.model.careList,
                              callback: function ($$v) {
                                _vm.$set(_vm.model, "careList", $$v)
                              },
                              expression: "model.careList",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.userInfo().username === "admin"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "心情灯设备号",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["moodLampId"],
                                    expression: "['moodLampId']",
                                  },
                                ],
                                attrs: { placeholder: "请输入心情灯设备号" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userInfo().username === "admin"
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "心情灯推送模型",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  dictCode: "lamp_send_model",
                                  placeholder: "请选择心情灯状态",
                                },
                                model: {
                                  value: _vm.model.lampSendModel,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.model, "lampSendModel", $$v)
                                  },
                                  expression: "model.lampSendModel",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "学生图片",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                          },
                        },
                        [
                          _c("j-image-upload", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["pic"],
                                expression: "['pic']",
                              },
                            ],
                            attrs: { bizPath: "headImg/" + _vm.tenantId },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }